import { MyDrive as MyDriveComponent } from '@openhouse-engineers/oh-shared-pages'
import React from 'react'

import { Modal } from 'components/Modal'
import { JEOPARDY_URLS } from 'constants.js'
import { featureTypes } from 'constants/mydrive'
import {
    emitToggleQuiz,
    emitToggleMyDrive,
    myDriveEventEmitter,
    myDriveKeys,
} from 'helpers/events'
import { accessTokenHelper } from 'helpers/token'
import { IFRAME, ROOM_STATE } from 'services/webSockets/roomState/constants'
import {
    dispatchSendSocketMessage,
    dispatchSetIsIframeShared,
    dispatchSetQuizSet,
} from 'store/dispatcher'

import { Container } from './styles'

const styles = {
    modal: {
        maxWidth: 920,
        maxHeight: 672,
        padding: 0,
        margin: 0,
    },
    root: {
        zIndex: 1,
    },
}

const config = {
    ohApiUrl: process.env.REACT_APP_OHR_V1_BASE_URL,
    accessToken: accessTokenHelper.get,
}

const MyDrive = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const [filter, setFilter] = React.useState('')

    React.useEffect(() => {
        const openModal = ({ state, type = '' }) => {
            setIsModalOpen(state)
            if (
                Object.values(featureTypes).find(
                    featureType => featureType === type
                )
            )
                setFilter(type)
            else setFilter('')
        }

        myDriveEventEmitter.addListener(myDriveKeys.OPEN_MY_DRIVE, openModal)

        return () => {
            myDriveEventEmitter.removeListener(
                myDriveKeys.OPEN_MY_DRIVE,
                openModal
            )
        }
    }, [])

    const onCloseModal = () => {
        setIsModalOpen(false)
        setFilter('')
    }

    const onPlayQuestionSet = data => {
        if (data.type === featureTypes.QUIZ) {
            dispatchSetQuizSet({
                ...data,
                name: data.title,
            })
            emitToggleQuiz()
        } else if (data.type === featureTypes.JEOPARDY) {
            const { play_url } = data
            if (play_url) {
                const teacherUrl = `${play_url}/play`
                const urlData = {
                    teacher_url: teacherUrl,
                    student_url: JEOPARDY_URLS.STUDENT_URL,
                }

                const roomStateData = {
                    action: ROOM_STATE,
                    state: IFRAME,
                    data: urlData,
                }
                dispatchSendSocketMessage(roomStateData)
            }
            // if no play_url handle UX
        }

        emitToggleMyDrive({ state: false })
    }

    return (
        <Modal
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
            styles={styles}
            showCloseIcon={false}
        >
            <Container>
                <MyDriveComponent
                    isMeets
                    onPlayQuestionSet={onPlayQuestionSet}
                    config={config}
                    filterBy={filter}
                />
            </Container>
        </Modal>
    )
}

export { MyDrive }
